import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TelekitList } from '../../core/_models'
import { TelekitsActionsCell } from './TelekitsActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { PlainHeader, sortableColumn, StackedCell, StatusBadge, TableColumn } from 'app/components'
import { Selo } from '../../../../dispositivos/components/Selos'

export const TelekitsColumns = (
  t: TFunction,
  opcoes: { mostrarRegime: boolean } = { mostrarRegime: false }
): ReadonlyArray<TableColumn<TelekitList>> => [
  sortableColumn<TelekitList>({
    id: 'identificador',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'identificador', label: t('cols.identificador') }],
    Cell: ({ row }: CellProps<TelekitList>) =>
      row.original.padrao ? (
        <Selo>{t('dispositivos.rotulos.maleta_padrao')}</Selo>
      ) : (
        <StackedCell tabular primary={row.original.identificador} />
      ),
  }),
  sortableColumn<TelekitList>({
    id: 'idPulsus',
    cellWidth: '160px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'idPulsus', label: t('cols.idPulsus') }],
    Cell: ({ row }: CellProps<TelekitList>) => (
      <StackedCell tabular primary={row.original.padrao ? '' : row.original.idPulsus} />
    ),
  }),
  sortableColumn<TelekitList>({
    id: 'empresa.nomeFantasia',
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('empresa.label') }],
    Cell: ({ row }: CellProps<TelekitList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  ...(opcoes.mostrarRegime
    ? [
        {
          Header: () => <PlainHeader>{t('pagina.dispositivos.col.regime')}</PlainHeader>,
          id: 'regime',
          cellWidth: '110px',
          hideOnMobile: true,
          Cell: ({ row }: CellProps<TelekitList>) =>
            row.original.regime === 'VENDIDO' ? (
              <Selo>{t('pagina.telekits.dispositivos.vendida')}</Selo>
            ) : (
              <StackedCell primary='' />
            ),
        } as TableColumn<TelekitList>,
      ]
    : []),
  sortableColumn<TelekitList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.status') }],
    Cell: ({ row }: CellProps<TelekitList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '210px',
    align: 'end',
    Cell: ({ row }: CellProps<TelekitList>) => <TelekitsActionsCell telekit={row.original} />,
  },
]
